// @flow
import ResourceFactory from 'app/common/lib/ResourceFactory';
import TopicActionTypes from 'app/common/redux/actions/topic/actionTypes';
import type { Thunk } from 'app/common/redux/types';
import { INTEREST_LIST_FAVORITED } from 'app/packages/pinterest-constants';

function getResource(id) {
  return ResourceFactory.create('InterestFollowResource', {
    interest_id: id,
    interest_list: INTEREST_LIST_FAVORITED,
  });
}

export type TopicFollow = {
  type: typeof TopicActionTypes.TOPIC_FOLLOW,
  payload: {
    id: string,
    value: boolean,
    showTooltip?: boolean,
  },
};

function followTopic(id: string, value: boolean, showTooltip?: boolean = false): TopicFollow {
  return {
    type: TopicActionTypes.TOPIC_FOLLOW,
    payload: {
      id,
      value,
      showTooltip,
    },
  };
}

export function follow(id: string, showTooltip?: boolean = false): Thunk<void> {
  return (dispatch) => {
    // on error, dispatch the unfollow action
    // todo (yen) - do we need to do more than this?
    getResource(id)
      .callCreate({ showError: false })
      .catch(() => dispatch(followTopic(id, false, showTooltip)));
    dispatch(followTopic(id, true, showTooltip));
  };
}

export function unfollow(id: string): Thunk<void> {
  return (dispatch) => {
    // on error, dispatch the follow action
    // todo (yen) - do we need to do more than this?
    getResource(id)
      .callDelete({ showError: false })
      .catch(() => dispatch(followTopic(id, true)));
    dispatch(followTopic(id, false));
  };
}
